<img src="/dist/img/icons/desktop-login.svg" alt="" />
<h5 class="subtitle">{{ "get_a_better_experience_on_desktop" | localize }}</h5>
<h6 class="description">{{ "use_the_link_we_ve_sent_to_your_email" | localize }}</h6>
